import keyMirror from 'fbjs/lib/keyMirror'

module.exports = keyMirror({
  UPDATE_INSTRUMENT: null
});


// WEBPACK FOOTER //
// ./src/modules/instrument/actionTypes.js